<template>
	<div v-if="routePath != null" :key="renderKey" class="map-legend map-path-switcher">
		<ul class="map-legend-list">
			<li v-if="isCustomRouteExist === false"
				v-on:click="enterToEditMode('custom')">
				<span class="route-provider-line custom"></span>
				<span>{{ app.Language.get('tours.providers.create_custom') }}</span>
			</li>
			<li v-bind:app="app"
				v-for="(item, index) in providersRoutes"
				v-bind:item="item"
				v-bind:key="item.id"
				v-bind:openRoutePath="openRoutePath"
				v-bind:closeRoutePath="closeRoutePath"
				v-on:click="switchRoutePathToProvider(routePath.key, item.provider)"
				v-on:dblclick="enterToEditMode(item.provider)"
				v-on="$listeners"
				:class="`${item.provider === routePath.provider ? 'is-selected' : ''}`">
				<span :class="`route-provider-line ${item.provider}`"></span>
				<span>{{ app.Language.get(`tours.providers.${item.provider}`) }}</span>
				<span class="route-provider-line-details is-pulled-right">
					{{ toHumanDistance(item.distance) }}, {{ toMinutes(item.time) }} мин.
				</span>
			</li>
		</ul>
		<div class="buttons are-small is-centered is-margin-top-1-rem">
			<button v-if="this.hasChanges" type="button" :class="`button is-info ${routePath.isLoading ? 'is-loading is-disabled' : ''}`" v-on:click="saveRoutePathProviderRoute(routePath.key)">
				{{ app.Language.get('_.save') }}
			</button>
			<button v-if="this.hasChanges" type="button" :class="`button ${routePath.isLoading ? 'is-disabled' : ''}`" v-on:click="revertRoutePathToOriginal(routePath.key)">
				{{ app.Language.get('_.cancel') }}
			</button>
			<button v-else type="button" class="button" v-on:click="closeRoutePath(routePath.key)">
				{{ app.Language.get('_.close') }}
			</button>
		</div>
	</div>
</template>

<script>
  import find from 'lodash/find';
  import { toHumanDistance, toMinutes } from "../../Helpers";
  import PROVIDERS_COLORS from "../RoutePathProvidersColors";

  const PROVIDERS = [
    'custom',
    'bing',
    'google',
    'mapbox',
    'mapQuest',
    'skobbler'
  ];

  export default {
    props: {
      app: Object,
      routePaths: Object,
      getRoutePathKey: Function,
      openRoutePath: Function,
      closeRoutePath: Function,
      switchRoutePathToProvider: Function,
      enterRoutePathToEditMode: Function,
      saveRoutePathProviderRoute: Function,
      revertRoutePathToOriginal: Function,
    },
    watch: {
      routePaths: {
        handler: function () {
          this.forceRerender();
        },
        immediate: true,
      }
    },
    data() {
      return {
        renderKey: 0,
      }
    },
    computed: {
      routePath() {

        let openedRoutePath = null;

        for (let key in this.routePaths) {
          if (this.routePaths.hasOwnProperty(key)) {
            let routePath = this.routePaths[key];
            if (typeof routePath !== 'undefined' && routePath.isOpened === true) {
              openedRoutePath = routePath;
            }
          }
        }

        return openedRoutePath;
      },
      providersRoutes() {
        let result = [];

        if (this.routePath == null) return result;

        PROVIDERS.forEach((provider) => {
          let route = find(this.routePath.providersRoutes, ['provider', provider]);
          if (typeof route !== 'undefined') {
            result.push(route);
		  }
		});

        return result;
	  },
	  hasProviderChanges() {
        return this.routePath.provider !== this.routePath.originalProvider;
	  },
	  hasPointsChanges() {
        let arePointsEqual = this.routePath.points === this.routePath.originalPoints;

        return (
		  (!arePointsEqual && this.routePath.provider === 'custom')
		  || false
		);
	  },
      hasChanges() {
        return this.hasProviderChanges || this.hasPointsChanges;
	  },
	  isCustomRouteExist() {
        return typeof find(this.routePath.providersRoutes, ['provider', 'custom']) !== 'undefined';
	  }
    },
    updated: function () {
      // this.$emit('update:objects', this.items);
    },
    methods: {
      forceRerender() {
        this.renderKey += 1;
      },
      toHumanDistance(value) {
        return toHumanDistance(value);
	  },
      toMinutes(value) {
        return toMinutes(value);
	  },
      enterToEditMode(provider) {
        if (provider === 'custom') {
          this.enterRoutePathToEditMode(this.routePath.key);
		}
	  }
    }
  }
</script>